module.exports = __webpack_public_path__ + "static/media/payment-failed-illustration.b68489f9.svg";